import styled from 'styled-components'

/* largura/expansão são controladas por style inline no componente
   (props dinâmicos do styled-components não reaplicam CSS neste dev) */
export const Sidebar = styled.aside`
  position: relative;
  z-index: 2; /* acima do conteudo a direita, senao a sombra fica escondida atras dele */
  flex-grow: 0;
  flex-shrink: 0;
  background: #d7dce3;
  border-radius: 0 18px 18px 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 18px 10px;
  gap: 8px;
  overflow: hidden;
  /* Mesma cor do header, projetada para a DIREITA e visivel (menu lateral esquerdo). */
  box-shadow: 4px 0 10px -1px rgba(0, 0, 0, 0.18);
`

export const SideItem = styled.button<{ active?: boolean }>`
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ active }) => (active ? '#3f444c' : '#8a929e')};
  background: ${({ active }) => (active ? '#c4cbd5' : 'transparent')};
  white-space: nowrap;
  overflow: hidden;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #cdd3dc;
    color: #3f444c;
  }

  svg {
    flex-shrink: 0;
  }

  .label {
    font-size: 16px;
    font-weight: 600;
    overflow: hidden;
  }
`

export const SideSpacer = styled.div`
  margin-top: auto;
`
